import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useThubanDocs = () => {
    const [thubanCodeEstatuto, setThubanCodeEstatuto] = useState("");
    const [thubanCodeModificacionesEstatuto, setThubanCodeModificacionesEstatuto] = useState("");
    const [thubanCodeActasDesignacion, setThubanCodeActasDesignacion] = useState("");
    const [thubanCodeActasDistribucion, setThubanCodeActasDistribucion] = useState("");
    const [thubanCodeBalanceActual, setThubanCodeBalanceActual] = useState("");
    const [thubanCodeBalanceAnterior, setThubanCodeBalanceAnterior] = useState("");
    const [thubanCodeActasGobiernoActual, setThubanCodeActasGobiernoActual] = useState("");
    const [thubanCodeActasGobiernoAnterior, setThubanCodeActasGobiernoAnterior] = useState("");
    const [thubanCodeVentas, setThubanCodeVentas] = useState("");
    const [thubanCodeIvaMesActual, setThubanCodeIvaMesActual] = useState("");
    const [thubanCodeIvaSegundoMes, setThubanCodeSegundoMes] = useState("");
    const [thubanCodeIvaTercerMes, setThubanCodeIvaTercerMes] = useState("");

    useEffect(() => {
        const estatuto = configUtils.get("onboarding.thuban.code.estatuto", "0A06");
        const modificacionesEstatuto = configUtils.get("onboarding.thuban.code.modificaciones_estatuto", "0B06");
        const actasDesignacion = configUtils.get("onboarding.thuban.code.actas_designacion", "0A07");
        const actasDistribucion = configUtils.get("onboarding.thuban.code.actas_distribucion", "0B07");
        const balanceActual = configUtils.get("onboarding.thuban.code.balance_actual", "0A13");
        const balanceAnterior = configUtils.get("onboarding.thuban.code.balance_anterior", "0B13");
        const actasGobiernoActual = configUtils.get("onboarding.thuban.code.actas_gobierno_actual", "0A15");
        const actasGobiernoAnterior = configUtils.get("onboarding.thuban.code.actas_gobierno_anterior", "0B15");
        const ventas = configUtils.get("onboarding.thuban.code.certificacion_ventas", "0017");
        const ivaMesActual = configUtils.get("onboarding.thuban.code.posicion_iva_mes_actual", "0A16");
        const ivaSegundoMes = configUtils.get("onboarding.thuban.code.posicion_iva_segundo_mes", "0B16");
        const ivaTercerMes = configUtils.get("onboarding.thuban.code.posicion_iva_tercer_mes", "0C16");
        setThubanCodeEstatuto(estatuto);
        setThubanCodeModificacionesEstatuto(modificacionesEstatuto);
        setThubanCodeActasDesignacion(actasDesignacion);
        setThubanCodeActasDistribucion(actasDistribucion);
        setThubanCodeBalanceActual(balanceActual);
        setThubanCodeBalanceAnterior(balanceAnterior);
        setThubanCodeActasGobiernoActual(actasGobiernoActual);
        setThubanCodeActasGobiernoAnterior(actasGobiernoAnterior);
        setThubanCodeVentas(ventas);
        setThubanCodeIvaMesActual(ivaMesActual);
        setThubanCodeSegundoMes(ivaSegundoMes);
        setThubanCodeIvaTercerMes(ivaTercerMes);
    }, []);

    return {
        thubanCodeEstatuto,
        thubanCodeModificacionesEstatuto,
        thubanCodeActasDesignacion,
        thubanCodeActasDistribucion,
        thubanCodeBalanceActual,
        thubanCodeBalanceAnterior,
        thubanCodeActasGobiernoActual,
        thubanCodeActasGobiernoAnterior,
        thubanCodeVentas,
        thubanCodeIvaMesActual,
        thubanCodeIvaSegundoMes,
        thubanCodeIvaTercerMes,
    };
};

export default useThubanDocs;
